// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3bXHZ","error":"Textarea_error__bVHJb","readonly":"Textarea_readonly__xWrLB","disabled":"Textarea_disabled__1-JjF"};